import React from 'react';
import iconImg from '../../assets/img/scantocad5/1.png';

const ScanToCad5 = () => {
  const cards = [
    {
      title: "As-Built Floor Plans",
      desc: "We convert point cloud data into detailed as-built floor plans that show walls, doors, windows, room layouts, openings, and key structural or architectural elements. These drawings are useful for renovation planning, tenant improvements, facility documentation, and design development."
    },
    {
      title: "Reflected Ceiling Plans",
      desc: "For projects requiring ceiling documentation, we prepare reflected ceiling plans showing lighting layouts, ceiling grids, soffits, HVAC locations, and other ceiling-mounted elements visible in the scan data."
    },
    {
      title: "Exterior Elevations",
      desc: "Our team creates accurate elevation drawings from scan data to help clients document façades, openings, height relationships, and architectural features. These are often needed for restoration, remodeling, redevelopment, and permit-related work."
    },
    {
      title: "MEP As-Built Drawings",
      desc: "Our point cloud to CAD services also support MEP documentation. We can draft visible pipes, ducts, equipment locations, and electrical layouts from scan data to support retrofits, coordination, and facility updates."
    },
    {
      title: "Building Sections",
      desc: "Section drawings give you a clear vertical understanding of the building. We prepare sections from point cloud data to show floor heights, roof slopes, stair relationships, ceiling levels, and other critical built conditions."
    },
    {
      title: "Existing Condition Drawings",
      desc: "When a property needs to be documented before design or construction starts, we create existing condition drawings from laser scan data to provide a reliable base for project planning."
    }
  ];

  return (
    <section className="scan-tocad5-section">
      <div className="stc5-container">
        <div className="stc5-header">
          <h2 className="stc5-main-title">
            <span className="text-primary">Our Scan to</span> CAD Services
          </h2>
          <p className="stc5-main-desc">
            We provide end-to-end scan to CAD drafting services tailored to project scope, drawing standards, and deliverable requirements. Our team works with registered scan data and point clouds to create clean, accurate 2D CAD files that support real project decisions.
          </p>
        </div>

        <div className="stc5-grid">
          {cards.map((card, index) => (
            <div className="stc5-card" key={index}>
              <div className="stc5-icon">
                <img src={iconImg.src || iconImg} alt="check icon" />
              </div>
              <h3 className="stc5-card-title">{card.title}</h3>
              <p className="stc5-card-desc">{card.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ScanToCad5;
